module.exports = __webpack_public_path__ + "img/left-pool.8950831b.svg";